// extracted by mini-css-extract-plugin
export default {"logo":"HomeLink_logo__n3Mci","transparent":"HomeLink_transparent__3I25l"};